/*
 Якщо значення порожнє — без повідомлення (обовʼязковість окремо).
 Якщо непорожнє але некоректне або < 0 — текст помилки українською.
*/
export function getNonNegativeMoneyMicrosValidationMessage(
	value: string | undefined,
): string | undefined {
	const trimmed = String(value ?? "").trim();
	if (!trimmed) return undefined;
	const n = Number(trimmed.replace(",", "."));
	if (!Number.isFinite(n)) return "Введіть коректне число";
	if (n < 0) return "Значення не може бути меншим за 0";
	return undefined;
}

/** target_cpa_micros у формі майстра */
export const getTargetCpaMicrosValidationMessage =
	getNonNegativeMoneyMicrosValidationMessage;

/** budget.amount_micros у формі майстра */
export const getBudgetAmountMicrosValidationMessage =
	getNonNegativeMoneyMicrosValidationMessage;

// Непорожній коректний рядок числа у валюті — скінченне число ≥ 0 (крапка/кома).
export const isNonNegativeMoneyAmountString = (
	value: string | undefined,
): boolean => {
	return (
		!!value?.trim() &&
		getNonNegativeMoneyMicrosValidationMessage(value) === undefined
	);
};
